// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimCoveragePeriodDto } from './IClaimCoveragePeriodDto';
import {
    IClaimCoveragePeriodDtoFromJSON,
    IClaimCoveragePeriodDtoFromJSONTyped,
    IClaimCoveragePeriodDtoToJSON,
    IClaimCoveragePeriodDtoToJSONTyped,
} from './IClaimCoveragePeriodDto';

/**
 * 
 * @export
 * @interface IClaimAccountOrderDto
 */
export interface IClaimAccountOrderDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimAccountOrderDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimAccountOrderDto
     */
    order?: number;
    /**
     * 
     * @type {Array<IClaimCoveragePeriodDto>}
     * @memberof IClaimAccountOrderDto
     */
    coverage_periods?: Array<IClaimCoveragePeriodDto>;
    /**
     * 
     * @type {string}
     * @memberof IClaimAccountOrderDto
     */
    proof_of_expenses_type?: IClaimAccountOrderDtoProofOfExpensesTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimAccountOrderDto
     */
    available_balance?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimAccountOrderDto
     */
    submit_claims_date_end?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IClaimAccountOrderDtoProofOfExpensesTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}


/**
 * Check if a given object implements the IClaimAccountOrderDto interface.
 */
export function instanceOfIClaimAccountOrderDto(value: object): value is IClaimAccountOrderDto {
    return true;
}

export function IClaimAccountOrderDtoFromJSON(json: any): IClaimAccountOrderDto {
    return IClaimAccountOrderDtoFromJSONTyped(json, false);
}

export function IClaimAccountOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimAccountOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'order': json['order'] == null ? undefined : json['order'],
        'coverage_periods': json['coverage_periods'] == null ? undefined : ((json['coverage_periods'] as Array<any>).map(IClaimCoveragePeriodDtoFromJSON)),
        'proof_of_expenses_type': json['proof_of_expenses_type'] == null ? undefined : json['proof_of_expenses_type'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'submit_claims_date_end': json['submit_claims_date_end'] == null ? undefined : (new Date(json['submit_claims_date_end'])),
    };
}

export function IClaimAccountOrderDtoToJSON(json: any): IClaimAccountOrderDto {
    return IClaimAccountOrderDtoToJSONTyped(json, false);
}

export function IClaimAccountOrderDtoToJSONTyped(value?: IClaimAccountOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'order': value['order'],
        'coverage_periods': value['coverage_periods'] == null ? undefined : ((value['coverage_periods'] as Array<any>).map(IClaimCoveragePeriodDtoToJSON)),
        'proof_of_expenses_type': value['proof_of_expenses_type'],
        'available_balance': value['available_balance'],
        'submit_claims_date_end': value['submit_claims_date_end'] == null ? undefined : ((value['submit_claims_date_end']).toISOString().substring(0,10)),
    };
}

